module.exports = __webpack_public_path__ + "98d161f8390bead5fa6b788b4fec334e.png";